// src/features/employee/EmployeeAttendance.js
import React from "react";

const EmployeeAttendance = ({ employeeId }) => {
  return (
    <div className="add-client-form">
      <div style={{ backgroundColor: "#fff", borderRadius: "8px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", overflow: "hidden" }}>
        <table style={{ 
          width: "100%", 
          borderCollapse: "collapse",
          backgroundColor: "#fff"
        }}>
          <thead>
            <tr style={{ borderBottom: "1px solid #e8e8e8" }}>
              <th style={{ 
                padding: "16px 24px", 
                textAlign: "center", 
                fontSize: "12px", 
                fontWeight: "700",
                color: "#999",
                backgroundColor: "#fafafa"
              }}>Date</th>
              <th style={{ 
                textAlign: "center", 
                fontSize: "12px", 
                fontWeight: "700",
                color: "#999",

                backgroundColor: "#fafafa"
              }}>Check In</th>
              <th style={{ 
                padding: "16px 24px", 
                textAlign: "center", 
                fontSize: "12px", 
                fontWeight: "700",
                color: "#999",
                backgroundColor: "#fafafa"
              }}>Check Out</th>
              <th style={{ 
                padding: "16px 24px", 
                textAlign: "center", 
                fontSize: "12px", 
                fontWeight: "700",
                color: "#999",
                backgroundColor: "#fafafa"
              }}>Break</th>
              <th style={{ 
                padding: "16px 24px", 
                textAlign: "center", 
                fontSize: "12px", 
                fontWeight: "700",
                color: "#999",
                backgroundColor: "#fafafa"
              }}>Working Hours</th>
              <th style={{ 
                padding: "16px 24px", 
                textAlign: "center", 
                fontSize: "12px", 
                fontWeight: "700",
                color: "#999",
                backgroundColor: "#fafafa"
              }}>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{ borderBottom: "1px solid #f5f5f5" }}>
              <td style={{ padding: "20px 24px", fontSize: "14px", color: "#333" }}>July 01, 2023</td>
              <td style={{ padding: "20px 24px", fontSize: "14px", color: "#333" }}>09:45 AM</td>
              <td style={{ padding: "20px 24px", fontSize: "14px", color: "#333" }}>08:00 PM</td>
              <td style={{ padding: "20px 24px", fontSize: "14px", color: "#666" }}>00:40 Min</td>
              <td style={{ padding: "20px 24px", fontSize: "14px", color: "#333" }}>08:35 Hrs</td>
              <td style={{ padding: "20px 24px", fontSize: "14px" }}>
                <span style={{ 
                  color: "#52c41a", 
                  backgroundColor: "#f6ffed",
                  padding: "4px 12px",
                  borderRadius: "4px",
                  fontSize: "12px",
                  fontWeight: "500"
                }}>On Time</span>
              </td>
            </tr>
            <tr style={{ borderBottom: "1px solid #f5f5f5" }}>
              <td style={{ padding: "20px 24px", fontSize: "14px", color: "#333" }}>July 02, 2023</td>
              <td style={{ padding: "20px 24px", fontSize: "14px", color: "#333" }}>09:00 AM</td>
              <td style={{ padding: "20px 24px", fontSize: "14px", color: "#333" }}>07:30 PM</td>
              <td style={{ padding: "20px 24px", fontSize: "14px", color: "#666" }}>00:40 Min</td>
              <td style={{ padding: "20px 24px", fontSize: "14px", color: "#333" }}>08:35 Hrs</td>
              <td style={{ padding: "20px 24px", fontSize: "14px" }}>
                <span style={{ 
                  color: "#ff4d4f", 
                  backgroundColor: "#fff1f0",
                  padding: "4px 12px",
                  borderRadius: "4px",
                  fontSize: "12px",
                  fontWeight: "500"
                }}>Late</span>
              </td>
            </tr>
            <tr style={{ borderBottom: "1px solid #f5f5f5" }}>
              <td style={{ padding: "20px 24px", fontSize: "14px", color: "#333" }}>July 03, 2023</td>
              <td style={{ padding: "20px 24px", fontSize: "14px", color: "#333" }}>08:45 AM</td>
              <td style={{ padding: "20px 24px", fontSize: "14px", color: "#333" }}>07:20 PM</td>
              <td style={{ padding: "20px 24px", fontSize: "14px", color: "#666" }}>00:40 Min</td>
              <td style={{ padding: "20px 24px", fontSize: "14px", color: "#333" }}>08:35 Hrs</td>
              <td style={{ padding: "20px 24px", fontSize: "14px" }}>
                <span style={{ 
                  color: "#52c41a", 
                  backgroundColor: "#f6ffed",
                  padding: "4px 12px",
                  borderRadius: "4px",
                  fontSize: "12px",
                  fontWeight: "500"
                }}>On Time</span>
              </td>
            </tr>
            <tr style={{ borderBottom: "1px solid #f5f5f5" }}>
              <td style={{ padding: "20px 24px", fontSize: "14px", color: "#333" }}>July 04, 2023</td>
              <td style={{ padding: "20px 24px", fontSize: "14px", color: "#333" }}>09:05 AM</td>
              <td style={{ padding: "20px 24px", fontSize: "14px", color: "#333" }}>07:00 PM</td>
              <td style={{ padding: "20px 24px", fontSize: "14px", color: "#666" }}>00:40 Min</td>
              <td style={{ padding: "20px 24px", fontSize: "14px", color: "#333" }}>08:35 Hrs</td>
              <td style={{ padding: "20px 24px", fontSize: "14px" }}>
                <span style={{ 
                  color: "#52c41a", 
                  backgroundColor: "#f6ffed",
                  padding: "4px 12px",
                  borderRadius: "4px",
                  fontSize: "12px",
                  fontWeight: "500"
                }}>On Time</span>
              </td>
            </tr>
            <tr style={{ borderBottom: "1px solid #f5f5f5" }}>
              <td style={{ padding: "20px 24px", fontSize: "14px", color: "#333" }}>July 05, 2023</td>
              <td style={{ padding: "20px 24px", fontSize: "14px", color: "#333" }}>09:15 AM</td>
              <td style={{ padding: "20px 24px", fontSize: "14px", color: "#333" }}>06:00 PM</td>
              <td style={{ padding: "20px 24px", fontSize: "14px", color: "#666" }}>00:40 Min</td>
              <td style={{ padding: "20px 24px", fontSize: "14px", color: "#333" }}>08:35 Hrs</td>
              <td style={{ padding: "20px 24px", fontSize: "14px" }}>
                <span style={{ 
                  color: "#52c41a", 
                  backgroundColor: "#f6ffed",
                  padding: "4px 12px",
                  borderRadius: "4px",
                  fontSize: "12px",
                  fontWeight: "500"
                }}>On Time</span>
              </td>
            </tr>
            
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EmployeeAttendance;
